// extracted by mini-css-extract-plugin
export default {"primary":"OrderTable_primary__kudZ5","secondary":"OrderTable_secondary__Z73RB","stack":"OrderTable_stack__GaY3i"};